<section class="panel"><div class="panel-heading"><h2>Administración de roles</h2><button type="button" class="btn-govco" (click)="create()">Nuevo rol</button></div>
<sr-admin-data-table label="Roles del sistema" [rows]="rows()" [columns]="columns" [actions]="actions" (action)="open($event)" />
@if(showForm){<sr-rol-formulario [role]="editing" (closed)="showForm=false" />}
@if(assigning){<sr-asignar-usuarios-rol [role]="assigning" (closed)="assigning=null" />}
</section>